export default __webpack_public_path__ + "static/articulo8-4e6a6338011fbe7883925d49c4d3417b.png";